import PageHeader from '../../components/PageHeader';
import FilterPanel from '../../components/FilterPanel';
import { useState } from 'react';
import DataTable from '../../components/DataTable';
import { formatDate } from '../../utils/formatters';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Card,
  MenuItem,
  Paper,
  Stack,
  TextField,
} from '@mui/material';
const STATUS_LABELS = {
  saved: 'ממתין לעיבוד',
  processed: 'התקבל',
  failed: 'נדחה',
  skipped: 'דולג',
};
const SOURCE_LABELS = {
  MANUAL_ON_THE_WAY: 'ידני – בדרך',
  MANUAL_NAVIGATION: 'ידני – ניווט',
  AUTO_GEOFENCE: 'אוטומטי',
};
const formatDuration = (milliseconds) => {
  if (!Number.isFinite(milliseconds)) return '-';
  const minutes = Math.floor(milliseconds / 60000);
  const seconds = Math.floor((milliseconds % 60000) / 1000);
  return `${minutes}:${String(seconds).padStart(2, '0')} דק׳`;
};
const valueOrDash = (value, suffix = '') =>
  value === null || value === undefined || value === '' ? '-' : `${value}${suffix}`;
const SummaryCard = ({ label, value, tone = '' }) => (
  <Card
    sx={String(`panel gps-summary-card ${tone}`)
      .split(/\s+/)
      .map(
        (name) =>
          ({
            'gps-summary-card': {
              minHeight: '86px',
              display: 'grid',
              alignContent: 'center',
              gap: '4px',
              padding: '14px 18px',
              borderRight: '4px solid #98a2b3',
              '& strong': {
                fontSize: '28px',
              },
            },
            panel: {
              background: 'var(--panel)',
              border: '1px solid var(--line)',
              borderRadius: '16px',
              borderColor: 'rgba(20,45,41,.11)',
              boxShadow: 'var(--shadow-sm)',
              backdropFilter: 'blur(10px)',
            },
          })[name],
      )
      .filter(Boolean)}
  >
    <Typography>{label}</Typography>
    <Typography>{value || 0}</Typography>
  </Card>
);
const GpsRawReportDialog = ({ report, onClose }) => {
  if (!report) return null;
  const generatedReport = report.generatedReportId;
  return (
    <Stack
      onMouseDown={onClose}
      sx={(theme) => ({
        position: 'fixed',
        inset: '0',
        zIndex: '30',
        display: 'grid',
        placeItems: 'center',
        padding: '24px',
        background: 'rgba(21, 33, 31, .56)',
        [theme.breakpoints.down('sm')]: {
          padding: '0',
        },
        backdropFilter: 'blur(6px)',
      })}
    >
      <Stack
        onMouseDown={(event) => event.stopPropagation()}
        sx={(theme) => ({
          width: 'min(1180px, 100%)',
          height: 'calc(100vh - 48px)',
          maxHeight: 'calc(100vh - 48px)',
          minHeight: '0',
          display: 'grid',
          gridTemplateRows: 'auto auto minmax(0, 1fr) auto',
          contain: 'layout',
          background: 'var(--panel)',
          borderRadius: '20px',
          boxShadow: 'var(--shadow-lg)',
          overflow: 'hidden',
          textAlign: 'right',
          [theme.breakpoints.down('sm')]: {
            width: '100%',
            height: '100vh',
            maxHeight: '100vh',
            minHeight: '100vh',
            borderRadius: '0',
          },
          border: '1px solid rgba(255,255,255,.45)',
        })}
      >
        <Stack
          sx={(theme) => ({
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '16px',
            padding: '20px 24px',
            borderBottom: '1px solid var(--line)',
            [theme.breakpoints.down('sm')]: {
              padding: '16px',
            },
          })}
        >
          <Stack>
            <Typography
              sx={{
                margin: '0 0 8px',
                color: 'var(--primary)',
                fontSize: '12px',
                fontWeight: '800',
                letterSpacing: '0',
                textTransform: 'uppercase',
                marginBottom: '9px',
              }}
            >
              דיווח GPS גולמי
            </Typography>
            <Typography>{report.placeName || report.placeId}</Typography>
            <Typography>{report.sessionId}</Typography>
          </Stack>
          <Button
            type="button"
            onClick={onClose}
            aria-label="סגירה"
            sx={{
              width: '42px',
              height: '42px',
              minHeight: '42px',
              borderRadius: '50%',
              padding: '0',
              fontSize: '28px',
              lineHeight: '1',
              background: '#eef2f6',
              color: 'var(--text)',
            }}
          >
            ×
          </Button>
        </Stack>
        <Stack
          sx={(theme) => ({
            minWidth: '0',
            minHeight: '0',
            height: '100%',
            overflowY: 'auto',
            overflowX: 'hidden',
            overscrollBehavior: 'contain',
            WebkitOverflowScrolling: 'touch',
            scrollbarGutter: 'stable',
            padding: '15px',
            display: 'grid',
            alignContent: 'start',
            gap: '24px',
            [theme.breakpoints.down('sm')]: {
              padding: '14px',
            },
          })}
        >
          <Stack
            sx={{
              border: '1px solid var(--line)',
              borderRadius: '14px',
              padding: '16px',
              background: '#fff',
            }}
          >
            <Stack
              sx={{
                display: 'none',
                justifyContent: 'space-between',
                alignItems: 'end',
                gap: '12px',
                marginBottom: '14px',
              }}
            >
              <Typography>פרטי הסשן והעיבוד</Typography>
            </Stack>
            <Stack
              sx={(theme) => ({
                display: 'grid',
                gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                gap: '14px',
                margin: '0',
              })}
            >
              <Stack>
                <Typography>סטטוס</Typography>
                <Typography>
                  <Typography
                    sx={String(`pill gps-status-${report.status}`)
                      .split(/\s+/)
                      .map(
                        (name) =>
                          ({
                            'gps-status-processed': {
                              background: '#dcfae6',
                              color: '#067647',
                            },
                            'gps-status-failed': {
                              background: '#fee4e2',
                              color: '#b42318',
                            },
                            'gps-status-skipped': {
                              background: '#fff6d6',
                              color: '#b54708',
                            },
                            'gps-status-saved': {
                              background: '#eef2ff',
                              color: '#3730a3',
                            },
                            pill: {
                              display: 'inline-flex',
                              alignItems: 'center',
                              minHeight: '26px',
                              borderRadius: '999px',
                              padding: '0 11px',
                              fontWeight: '800',
                              fontSize: '12px',
                              background: '#eef2f6',
                              color: '#344054',
                            },
                          })[name],
                      )
                      .filter(Boolean)}
                  >
                    {STATUS_LABELS[report.status] || report.status}
                  </Typography>
                </Typography>
              </Stack>
              <Stack>
                <Typography>סיבת דחייה / דילוג</Typography>
                <Typography>{valueOrDash(report.processingError)}</Typography>
              </Stack>
              <Stack>
                <Typography>מקור</Typography>
                <Typography>{SOURCE_LABELS[report.source] || report.source}</Typography>
              </Stack>
              <Stack>
                <Typography>סיבת עצירה</Typography>
                <Typography>{valueOrDash(report.stoppedReason)}</Typography>
              </Stack>
              <Stack>
                <Typography>Session ID</Typography>
                <Typography>{report.sessionId}</Typography>
              </Stack>
              <Stack>
                <Typography>מזהה רשומה</Typography>
                <Typography>{report._id}</Typography>
              </Stack>
              <Stack>
                <Typography>Place ID</Typography>
                <Typography>{report.placeId}</Typography>
              </Stack>
              <Stack>
                <Typography>שם מקום</Typography>
                <Typography>{valueOrDash(report.placeName)}</Typography>
              </Stack>
              <Stack>
                <Typography>סוג התנהגות</Typography>
                <Typography>{valueOrDash(report.behaviorType)}</Typography>
              </Stack>
              <Stack>
                <Typography>משך ביקור</Typography>
                <Typography>
                  {formatDuration(report.visitDurationMs)} (
                  {valueOrDash(report.visitDurationMs, ' ms')})
                </Typography>
              </Stack>
              <Stack>
                <Typography>הגעה</Typography>
                <Typography>{formatDate(report.arrivedAt)}</Typography>
              </Stack>
              <Stack>
                <Typography>עזיבה</Typography>
                <Typography>{formatDate(report.leftAt)}</Typography>
              </Stack>
              <Stack>
                <Typography>נוצר</Typography>
                <Typography>{formatDate(report.createdAt)}</Typography>
              </Stack>
              <Stack>
                <Typography>עובד</Typography>
                <Typography>{report.processedAt ? formatDate(report.processedAt) : '-'}</Typography>
              </Stack>
              <Stack>
                <Typography>Device ID</Typography>
                <Typography>{valueOrDash(report.deviceId)}</Typography>
              </Stack>
              <Stack>
                <Typography>Anonymous ID</Typography>
                <Typography>{valueOrDash(report.anonymousId)}</Typography>
              </Stack>
              <Stack>
                <Typography>User ID</Typography>
                <Typography>{valueOrDash(report.userId)}</Typography>
              </Stack>
              <Stack>
                <Typography>מספר דגימות</Typography>
                <Typography>{report.samples?.length || 0}</Typography>
              </Stack>
              <Stack>
                <Typography>מרחק ביציאה</Typography>
                <Typography>{valueOrDash(report.exitDistanceMeters, ' מ׳')}</Typography>
              </Stack>
              <Stack>
                <Typography>דיוק ביציאה</Typography>
                <Typography>{valueOrDash(report.exitAccuracyMeters, ' מ׳')}</Typography>
              </Stack>
              <Stack>
                <Typography>מהירות ביציאה</Typography>
                <Typography>{valueOrDash(report.exitSpeedKmh, ' קמ״ש')}</Typography>
              </Stack>
              <Stack>
                <Typography>דיווח עומס שנוצר</Typography>
                <Typography>{generatedReport?._id || '-'}</Typography>
              </Stack>
              <Stack>
                <Typography>ציון עומס</Typography>
                <Typography>{valueOrDash(generatedReport?.loadScore)}</Typography>
              </Stack>
              <Stack>
                <Typography>ביטחון GPS</Typography>
                <Typography>{valueOrDash(generatedReport?.metadata?.gpsConfidence)}</Typography>
              </Stack>
              <Stack>
                <Typography>סיבת ציון GPS</Typography>
                <Typography>{valueOrDash(generatedReport?.metadata?.gpsReason)}</Typography>
              </Stack>
            </Stack>
          </Stack>

          <Stack
            sx={{
              border: '1px solid var(--line)',
              borderRadius: '14px',
              padding: '16px',
              background: '#fff',
            }}
          >
            <Stack
              sx={{
                display: 'none',
                justifyContent: 'space-between',
                alignItems: 'end',
                gap: '12px',
                marginBottom: '14px',
              }}
            >
              <Typography>דגימות GPS ({report.samples?.length || 0})</Typography>
            </Stack>
            <Paper
              sx={(theme) => ({
                background: 'rgba(255,255,255,.96)',
                border: '1px solid var(--line)',
                borderRadius: '16px',
                borderColor: 'rgba(20,45,41,.11)',
                boxShadow: 'var(--shadow-sm)',
                backdropFilter: 'blur(10px)',
                overflow: 'auto',
                direction: 'rtl',
                [theme.breakpoints.down('sm')]: {
                  borderRadius: '12px',
                },
                maxHeight: '360px',
                '& table': {
                  minWidth: '850px',
                },
              })}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>זמן</TableCell>
                    <TableCell>Latitude</TableCell>
                    <TableCell>Longitude</TableCell>
                    <TableCell>דיוק</TableCell>
                    <TableCell>מהירות</TableCell>
                    <TableCell>מרחק</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(report.samples || []).map((sample, index) => (
                    <TableRow key={`${sample.timestamp}-${index}`}>
                      <TableCell>{formatDate(new Date(sample.timestamp))}</TableCell>
                      <TableCell>{sample.latitude}</TableCell>
                      <TableCell>{sample.longitude}</TableCell>
                      <TableCell>{valueOrDash(sample.accuracy, ' מ׳')}</TableCell>
                      <TableCell>{valueOrDash(sample.speed)}</TableCell>
                      <TableCell>{valueOrDash(sample.distanceMeters, ' מ׳')}</TableCell>
                    </TableRow>
                  ))}
                  {!report.samples?.length && (
                    <TableRow
                      sx={{
                        '& td': {
                          padding: '28px 12px',
                          color: 'var(--muted)',
                          textAlign: 'center',
                        },
                        '&:hover': {
                          background: 'transparent',
                        },
                      }}
                    >
                      <TableCell colSpan="6">אין דגימות</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Paper>
          </Stack>

          <Paper
            sx={{
              border: '1px solid var(--line)',
              borderRadius: '8px',
              padding: '14px 16px',
              background: '#f8fafc',
              '& summary': {
                cursor: 'pointer',
                fontWeight: '800',
              },
              '& pre': {
                maxHeight: '440px',
                overflow: 'auto',
                margin: '14px 0 0',
                padding: '14px',
                borderRadius: '6px',
                background: '#172033',
                color: '#e4e7ec',
                textAlign: 'left',
                whiteSpace: 'pre-wrap',
                overflowWrap: 'anywhere',
              },
            }}
          >
            <Button>כל הנתונים הגולמיים (JSON)</Button>
            <Typography dir="ltr">{JSON.stringify(report, null, 2)}</Typography>
          </Paper>
        </Stack>
        <Stack
          sx={(theme) => ({
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '16px',
            padding: '20px 24px',
            borderBottom: '0',
            borderTop: '1px solid var(--line)',
            [theme.breakpoints.down('sm')]: {
              padding: '16px',
              position: 'sticky',
              bottom: '0',
              flexWrap: 'wrap',
              background: '#fff',
              '& button': {
                flex: '1 1 120px',
              },
            },
          })}
        >
          <Button
            type="button"
            onClick={onClose}
            sx={{
              background: '#edf2f7',
              color: 'var(--text)',
              '&:hover': {
                background: '#ddebff',
                color: '#1269e8',
              },
            }}
          >
            סגירה
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
const GpsRawReportsPage = ({ reports, filters, setFilters, loadReports, loading }) => {
  const [selectedReport, setSelectedReport] = useState(null);
  const summary = reports.summary || {};
  const columns = [
    {
      key: 'createdAt',
      label: 'נוצר',
      render: (report) => formatDate(report.createdAt),
    },
    {
      key: 'place',
      label: 'מקום',
      render: (report) => report.placeName || report.placeId,
    },
    {
      key: 'source',
      label: 'מקור',
      render: (report) => SOURCE_LABELS[report.source] || report.source,
    },
    {
      key: 'status',
      label: 'סטטוס',
      render: (report) => (
        <Typography
          sx={String(`pill gps-status-${report.status}`)
            .split(/\s+/)
            .map(
              (name) =>
                ({
                  'gps-status-processed': {
                    background: '#dcfae6',
                    color: '#067647',
                  },
                  'gps-status-failed': {
                    background: '#fee4e2',
                    color: '#b42318',
                  },
                  'gps-status-skipped': {
                    background: '#fff6d6',
                    color: '#b54708',
                  },
                  'gps-status-saved': {
                    background: '#eef2ff',
                    color: '#3730a3',
                  },
                  pill: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    minHeight: '26px',
                    borderRadius: '999px',
                    padding: '0 11px',
                    fontWeight: '800',
                    fontSize: '12px',
                    background: '#eef2f6',
                    color: '#344054',
                  },
                })[name],
            )
            .filter(Boolean)}
        >
          {STATUS_LABELS[report.status] || report.status}
        </Typography>
      ),
    },
    {
      key: 'processingError',
      label: 'סיבה',
      render: (report) => report.processingError || '-',
    },
    {
      key: 'duration',
      label: 'משך',
      render: (report) => formatDuration(report.visitDurationMs),
    },
    {
      key: 'samples',
      label: 'דגימות',
      render: (report) => report.samples?.length || 0,
    },
    {
      key: 'loadScore',
      label: 'ציון',
      render: (report) => valueOrDash(report.generatedReportId?.loadScore),
    },
  ];
  return (
    <Stack
      sx={(theme) => ({
        display: 'grid',
        gridTemplateRows: 'auto minmax(0, 1fr)',
        gap: '16px',
        height: '100%',
        minHeight: 0,
        overflow: 'hidden',
      })}
    >
      <PageHeader title={<>דיווחי GPS גולמיים</>} meta={<>{reports.total} דיווחים</>}>
        <FilterPanel className="gps-raw-filters">
          <TextField
            type="date"
            value={filters.gpsFrom}
            onChange={(event) =>
              setFilters({
                ...filters,
                gpsFrom: event.target.value,
              })
            }
            fullWidth
          />
          <TextField
            type="date"
            value={filters.gpsTo}
            onChange={(event) =>
              setFilters({
                ...filters,
                gpsTo: event.target.value,
              })
            }
            fullWidth
          />
          <TextField
            value={filters.gpsStatus}
            onChange={(event) =>
              setFilters({
                ...filters,
                gpsStatus: event.target.value,
              })
            }
            select
            fullWidth
          >
            <MenuItem value="">כל הסטטוסים</MenuItem>
            <MenuItem value="processed">התקבל</MenuItem>
            <MenuItem value="failed">נדחה</MenuItem>
            <MenuItem value="skipped">דולג</MenuItem>
            <MenuItem value="saved">ממתין</MenuItem>
          </TextField>
          <TextField
            value={filters.gpsSource}
            onChange={(event) =>
              setFilters({
                ...filters,
                gpsSource: event.target.value,
              })
            }
            select
            fullWidth
          >
            <MenuItem value="">כל המקורות</MenuItem>
            <MenuItem value="AUTO_GEOFENCE">אוטומטי</MenuItem>
            <MenuItem value="MANUAL_ON_THE_WAY">ידני – בדרך</MenuItem>
            <MenuItem value="MANUAL_NAVIGATION">ידני – ניווט</MenuItem>
          </TextField>
          <TextField
            placeholder="Place ID"
            value={filters.gpsPlaceId}
            onChange={(event) =>
              setFilters({
                ...filters,
                gpsPlaceId: event.target.value,
              })
            }
            fullWidth
          />
          <Button onClick={() => loadReports(1)}>סינון</Button>
        </FilterPanel>
      </PageHeader>

      <Stack
        sx={(theme) => ({
          display: 'grid',
          gridTemplateRows: 'auto minmax(0, 1fr)',
          gap: '16px',
          minHeight: 0,
          overflow: 'hidden',
          [theme.breakpoints.down('sm')]: {
            display: 'flex',
            overflowY: 'auto',
            overflowX: 'hidden',
            overscrollBehavior: 'contain',
            paddingBottom: 1,
          },
        })}
      >
        <Stack
          sx={(theme) => ({
            display: 'grid',
            gridTemplateColumns: 'repeat(6, minmax(110px, 1fr))',
            gap: '12px',
            [theme.breakpoints.down('lg')]: { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' },
            [theme.breakpoints.down('sm')]: { gridTemplateColumns: '1fr' },
          })}
        >
          <SummaryCard label="סה״כ דיווחים" value={summary.total} />
          <SummaryCard label="התקבלו" value={summary.processed} tone="success" />
          <SummaryCard label="נדחו" value={summary.rejected} tone="danger" />
          <SummaryCard label="דולגו" value={summary.skipped} tone="skipped" />
          <SummaryCard label="אוטומטיים" value={summary.automatic} tone="info" />
          <SummaryCard label="ידניים" value={summary.manual} tone="warning" />
        </Stack>
        <Stack sx={{ minHeight: { xs: 520, sm: 0 } }}>
          <DataTable
            columns={columns}
            items={reports.items}
            rowKey={(report) => report._id}
            onRowClick={setSelectedReport}
            page={reports.page}
            limit={reports.limit}
            total={reports.total}
            onPageChange={loadReports}
            loading={loading}
            wide
          />
        </Stack>
      </Stack>
      <GpsRawReportDialog report={selectedReport} onClose={() => setSelectedReport(null)} />
    </Stack>
  );
};
export default GpsRawReportsPage;
